export default {
  amount : window.slider_amounts || [
    10000,
    15000,
    20000,
    25000,
    30000,
    35000,
    40000,
    45000,
    50000,
    60000,
    70000,
    80000,
    90000,
    100000,
    110000,
    120000,
    130000,
    140000,
    150000,
    160000,
    170000,
    180000,
    190000,
    200000,
    225000,
    250000,
    275000,
    300000,
    325000,
    350000,
    375000,
    400000,
    425000,
    450000,
    475000,
    500000,
    550000,
    600000,
    650000,
    700000,
    750000,
    800000,
    850000,
    900000,
    950000,
    1000000,
    1100000,
    1200000,
    1300000,
    1400000,
    1500000,
    1600000,
    1700000,
    1800000,
    1900000,
    2000000,
    2250000,
    2500000,
    3000000,
    3500000,
    4000000,
    4500000,
    5000000,
  ],
  repayment : window.slider_periods || [
    12,
    24,
    36,
    48,
    60,
    72,
    84,
    96,
    108,
    120,
    132,
    144,
  ],
  default: {
    amount: window.default_slider_amount || window.loan_data.business.amount || 25000,
    repayment: window.default_slider_period || window.loan_data.business.repayment || 48,
  },
  onChange(slider) {
    slider.link.setAttribute('href', '#loan-list')

    window.loanLists[0].filter( x => {
      return x.max_amount >= slider.calculator.amount && x.min_amount <= slider.calculator.amount;
    })

    slider.link.innerText = `Jämför ${window.loanLists[0].count()} långivare`

    // console.log('Filter business loans')

  },
}



// WEBPACK FOOTER //
// ./scripts/Data/business-config.js